module.exports = __webpack_public_path__ + "img/delete-dark.33e37ef3.svg";